<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>Elimina</title>
    <path
      d="M16.035 21.927h-8.07c-1.338 0-2.477-.956-2.708-2.273l-.578-9.921a.75.75 0 1 1 1.478-.26l.578 9.921c.105.599.623 1.033 1.231 1.033h8.07a1.25 1.25 0 0 0 1.231-1.033l.566-9.921a.75.75 0 0 1 .868-.609.75.75 0 0 1 .608.869l-.566 9.921c-.231 1.317-1.37 2.273-2.708 2.273zm4.054-14.354H3.911a.75.75 0 1 1 0-1.5h3.964v-1.25c0-1.517 1.233-2.75 2.75-2.75h2.75c1.517 0 2.75 1.233 2.75 2.75v1.25h3.964a.75.75 0 1 1 0 1.5zm-10.714-1.5h5.25v-1.25a1.25 1.25 0 0 0-1.25-1.25h-2.75a1.25 1.25 0 0 0-1.25 1.25v1.25z"
      fill="#fb5e55"
    />
  </svg>
</template>

<script>
export default {};
</script>
